<template>
  <v-container class="page-content px-5" style="width: 100%">
    <v-card>
      <v-toolbar
          class="removeBtnPaddingRight pl-2"
          color="#DADADA"
          dense
          flat
      >
      </v-toolbar>
      <v-card-text>
        <v-alert outlined type="info" >
          Данная ссылка предназначена для авторизации работников охраны в системе
        </v-alert>
        <v-row no-gutters class="text-left subtitle-1 py-1">
          <v-col cols="4" md="2" class="font-weight-bold">Ссылка:</v-col>
          <v-col cols="8" md="6" class="text-right text-md-left">
            {{item.url}}
            <v-tooltip bottom>
              <template v-slot:activator="{ on }" >
                <v-btn v-on="on" icon @click="copyGuardLogin(item.url)">
                  <v-icon>file_copy</v-icon>
                </v-btn>
              </template>
              <span>Скопировать ссылку</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>


import {mapActions, mapGetters} from "vuex";
import entitled from "@/urls/roles/entitled";
import names_core from "@/modules/core/routers/names";

export default {
  name: "EntitledGuardMain",
  data() {
    return {
      page_title: "Доступ охраны"
    }
  },
  computed: {
    ...mapGetters({
      item: "entitled/getGuardLogin"
    })
  },
  methods: {
    ...mapActions({
      loadGuardLogin: "entitled/loadGuardLogin"
    }),
    copyGuardLogin : function (message) {
      navigator.clipboard.writeText(message);
    },
    loadData(url = undefined) {
      this.loadGuardLogin({
        url: url
      })
    }
  },
  created() {
    if(entitled.ENTITLED.ALLOWED()) {
      this.loadData()
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}

</script>

<style scoped>

</style>
